Namespace 'Monitoring.Reports.Publications.Content'

class Monitoring.Reports.Publications.Content.NotesView extends Backbone.View

  className: 'content-section content-notes'
  template: JST['backbone/templates/monitoring/reports/publications/content/notes']

  initialize: (@options = {}) ->

    # just set @options

  render: ->

    content = @options.contents[0]
    $.ajax
      method: 'GET',
      url: '/monitoring/dashboard/notes'
      data:
        content_id: content.id
      success: @renderResults
      error: @fail

  renderResults: (notes) =>

    @$el.html(@template(notes))
    @trigger('rendered')

  fail: =>

    @trigger('fail')
